import { call, put } from 'redux-saga/effects';
import {
    requestGetQuotes, requestGetQuote, requestCreateQuote, requestUpdateQuote,
    requestApproveQuote, requestRejectQuote,
    requestAcceptQuote, requestDeclineQuote, requestQuotePdf, requestReopenQuote, requestCloneQuote
} from '../requests/quote';
import { setQuotes, setCurrentQuote, setQuoteStatus } from '../../slices/quote';
import { showAlert } from '../../slices/alerts';
import { safeErrorMessage } from '../../../utils/errorUtils';

export function* handleGetQuotes(action) {
    try {
        const { params, callback } = action.payload || {};
        const response = yield call(requestGetQuotes, params || {});
        if (callback) { callback(response.data); }
        else { yield put(setQuotes(response.data)); }
    } catch (error) {
        yield put(showAlert({ severity: "error", message: safeErrorMessage(error) }));
    }
}

export function* handleGetQuote(action) {
    const { quoteId, callback } = action.payload || {};
    try {
        const response = yield call(requestGetQuote, quoteId);
        if (callback) { callback(response.data); }
        else { yield put(setCurrentQuote(response.data)); }
    } catch (error) {
        if (callback) { callback(null); }
        yield put(showAlert({ severity: "error", message: safeErrorMessage(error) }));
    }
}

export function* handleCreateQuote(action) {
    try {
        const { data, callback } = action.payload;
        const response = yield call(requestCreateQuote, data);
        if (callback) { callback(response.data); }
        else { yield put(setCurrentQuote(response.data)); }
    } catch (error) {
        yield put(showAlert({ severity: "error", message: safeErrorMessage(error) }));
    }
}

export function* handleUpdateQuote(action) {
    try {
        const { quoteId, data, callback } = action.payload;
        const response = yield call(requestUpdateQuote, quoteId, data);
        if (callback) { callback(response.data); }
        else { yield put(setCurrentQuote(response.data)); }
    } catch (error) {
        yield put(showAlert({ severity: "error", message: safeErrorMessage(error) }));
    }
}

export function* handleApproveQuote(action) {
    const { quoteId, callback } = action.payload || {};
    try {
        const response = yield call(requestApproveQuote, quoteId);
        if (callback) { callback(response.data); }
        else { yield put(setQuoteStatus({ status: response.data.status })); }
    } catch (error) {
        if (callback) { callback(null); }
        yield put(showAlert({ severity: "error", message: safeErrorMessage(error) }));
    }
}

export function* handleRejectQuote(action) {
    try {
        const { quoteId, callback } = action.payload;
        const response = yield call(requestRejectQuote, quoteId);
        if (callback) { callback(response.data); }
        else { yield put(setQuoteStatus({ status: response.data.status })); }
    } catch (error) {
        yield put(showAlert({ severity: "error", message: safeErrorMessage(error) }));
    }
}

export function* handleAcceptQuote(action) {
    try {
        const { quoteId, data, callback } = action.payload;
        const response = yield call(requestAcceptQuote, quoteId, data);
        if (callback) { callback(response.data); }
        // response.data = { quote, project } — caller uses callback for redirect
    } catch (error) {
        const { callback } = action.payload || {};
        if (callback) { callback(null); }
        yield put(showAlert({ severity: "error", message: safeErrorMessage(error) }));
    }
}

export function* handleDeclineQuote(action) {
    try {
        const { quoteId, data, callback } = action.payload;
        const response = yield call(requestDeclineQuote, quoteId, data);
        if (callback) { callback(response.data); }
        else { yield put(setQuoteStatus({ status: response.data.status })); }
    } catch (error) {
        const { callback } = action.payload || {};
        if (callback) { callback(null); }
        yield put(showAlert({ severity: "error", message: safeErrorMessage(error) }));
    }
}

export function* handleReopenQuote(action) {
    const { quoteId, callback } = action.payload || {};
    try {
        const response = yield call(requestReopenQuote, quoteId);
        if (callback) { callback(response.data); }
        else { yield put(setQuoteStatus({ status: response.data.status })); }
    } catch (error) {
        if (callback) { callback(null); }
        yield put(showAlert({ severity: "error", message: safeErrorMessage(error) }));
    }
}

export function* handleCloneQuote(action) {
    const { quoteId, callback } = action.payload || {};
    try {
        const response = yield call(requestCloneQuote, quoteId);
        if (callback) { callback(response.data); }
    } catch (error) {
        if (callback) { callback(null); }
        yield put(showAlert({ severity: "error", message: safeErrorMessage(error) }));
    }
}

export function* handlePreviewQuotePdf(action) {
    const { quoteId, callback } = action.payload || {};
    try {
        const response = yield call(requestQuotePdf, quoteId);
        if (callback) { callback(response.data); }
    } catch (error) {
        let message = safeErrorMessage(error);
        const data = error?.response?.data;
        if (data instanceof Blob) {
            try {
                const body = JSON.parse(yield call([data, data.text]));
                message = body.msg || body.message || body.error || message;
            } catch (e) { /* non-JSON error body */ }
        }
        if (callback) { callback(null); }
        yield put(showAlert({ severity: "error", message }));
    }
}
